export const initGlobal = {};
